(function () {
  function initGgmWidget() {
    const fab = document.getElementById('ggmFab');
    const panel = document.getElementById('ggmPanel');
    const back = document.getElementById('ggmBackdrop');
    const closeBtn = document.getElementById('ggmClose');

    const form = document.getElementById('ggmForm');
    const nameEl = document.getElementById('ggmName');
    const emailEl = document.getElementById('ggmEmail');
    const msgEl = document.getElementById('ggmMsg');
    const websiteEl = document.getElementById('ggmHoneypot');

    const toast = document.getElementById('ggmToast');

    const thanks = document.getElementById('ggmThanks');
    const thanksTitle = document.getElementById('ggmThanksTitle');
    const thanksText = document.getElementById('ggmThanksText');
    const thanksClose = document.getElementById('ggmThanksClose');

    if (!fab || !panel || !back) return;

    // prevent double-binding
    if (fab.dataset.ggmBound === '1') return;
    fab.dataset.ggmBound = '1';

    const inEditor = !!(window.Shopify && Shopify.designMode);
    const cfg = window.GGM_WIDGET || {};

    const autoOpenAfterMs = inEditor ? 0 : Number(cfg.auto_open_ms ?? 0);
    const thanksAutoCloseMs = Number(cfg.thanks_auto_close_ms ?? 2600);
    const thanksFadeMs = Number(cfg.thanks_fade_ms ?? 350);

    const seenKey = 'ggmHelpSeen_v1';
    const thanksPendingKey = 'ggmThanksPending_v1';
    const draftKey = 'ggmHelpDraft_v1';

    // i18n from Liquid (optional)
    const i18n = (cfg.i18n && typeof cfg.i18n === 'object') ? cfg.i18n : {};
    const TEXT = {
      thanksTitle: i18n.thanksTitle || 'Thank you!',
      thanksBody: i18n.thanksBody || 'Your request has been sent. We’ll get back to you as soon as possible.',
      msgPrefill: i18n.msgPrefill || 'Hello! I have a question about:',
      required: i18n.required || 'This field is required.',
      invalidEmail: i18n.invalidEmail || 'Please enter a valid email.',
      sending: i18n.sending || 'Sending…'
    };

    let lastFocusEl = null;

    function isOpen() {
      return panel.classList.contains('show');
    }

    function showToast(msg, ms = 2600) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('show');
      clearTimeout(showToast._t);
      showToast._t = setTimeout(() => toast.classList.remove('show'), ms);
    }

    function safeGetSeen() {
      try {
        return sessionStorage.getItem(seenKey);
      } catch (_) {
        return null;
      }
    }

    function safeSetSeen() {
      try {
        sessionStorage.setItem(seenKey, '1');
      } catch (_) {}
    }

    function setBadgeVisible(visible) {
      const badge = document.getElementById('ggmFabBadge');
      if (!badge) return;

      if (visible) {
        badge.textContent = '1';
        fab.classList.add('has-badge');
      } else {
        badge.textContent = '';
        fab.classList.remove('has-badge');
      }
    }

    const alreadySeen = !!safeGetSeen();
    setBadgeVisible(inEditor ? true : !alreadySeen);

    function markSeen() {
      safeSetSeen();
      if (inEditor) {
        setBadgeVisible(true);
      } else {
        setBadgeVisible(false);
      }
    }

    function openPanel() {
      lastFocusEl = document.activeElement;

      panel.classList.add('show');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ggm-widget-open');

      back.classList.add('show');
      back.setAttribute('aria-hidden', 'false');

      fab.classList.add('is-hidden');
      markSeen();

      setTimeout(() => {
        if (nameEl) nameEl.focus();
      }, 0);
    }

    function closePanel() {
      panel.classList.remove('show');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ggm-widget-open');

      back.classList.remove('show');
      back.setAttribute('aria-hidden', 'true');

      fab.classList.remove('is-hidden');

      const target = (lastFocusEl && typeof lastFocusEl.focus === 'function') ? lastFocusEl : fab;
      try {
        if (target && target.focus) target.focus();
      } catch (_) {}
    }

    function showThanks() {
      if (!thanks || !thanksTitle || !thanksText) return;

      thanksTitle.textContent = TEXT.thanksTitle;
      thanksText.textContent = TEXT.thanksBody;

      lastFocusEl = document.activeElement;

      thanks.classList.add('show');
      thanks.classList.remove('fade');
      thanks.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        if (thanksClose) thanksClose.focus();
      }, 0);

      clearTimeout(showThanks._t);
      showThanks._t = setTimeout(() => {
        thanks.classList.add('fade');
        setTimeout(() => hideThanks(false), thanksFadeMs);
      }, thanksAutoCloseMs);
    }

    function hideThanks(immediate) {
      if (!thanks) return;

      if (immediate) {
        clearTimeout(showThanks._t);
        thanks.classList.remove('fade');
        thanks.classList.remove('show');
        thanks.setAttribute('aria-hidden', 'true');
      } else {
        thanks.classList.remove('show');
        thanks.setAttribute('aria-hidden', 'true');
      }

      const target = (lastFocusEl && typeof lastFocusEl.focus === 'function') ? lastFocusEl : fab;
      try {
        if (target && target.focus) target.focus();
      } catch (_) {}
    }

    function getFieldWrap(el) {
      if (!el) return null;
      return el.closest('.ggm-field');
    }

    function setFieldError(el, message) {
      if (!el) return;
      const wrap = getFieldWrap(el);
      el.classList.add('ggm-input--error');
      el.classList.remove('ggm-input--ok');
      el.setAttribute('aria-invalid', 'true');

      if (!wrap) return;
      let err = wrap.querySelector('.ggm-error');
      if (!err) {
        err = document.createElement('div');
        err.className = 'ggm-error';
        wrap.appendChild(err);
      }
      err.textContent = message || TEXT.required;
    }

    function clearFieldError(el) {
      if (!el) return;
      const wrap = getFieldWrap(el);
      el.classList.remove('ggm-input--error');
      el.removeAttribute('aria-invalid');
      if (!wrap) return;
      const err = wrap.querySelector('.ggm-error');
      if (err) err.remove();
    }

    function scrollFieldIntoView(el) {
      if (!el) return;
      try {
        el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (_) {
        el.scrollIntoView(true);
      }
    }

    // ===== Live validation (email) =====
    function validateEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    if (nameEl) {
      nameEl.addEventListener('input', () => {
        if (nameEl.value.trim()) clearFieldError(nameEl);
      });
    }

    if (emailEl) {
      const applyEmailState = () => {
        const v = emailEl.value.trim();

        if (!v) {
          emailEl.classList.remove('ggm-input--error', 'ggm-input--ok');
          clearFieldError(emailEl);
          return;
        }

        const ok = validateEmail(v);
        emailEl.classList.toggle('ggm-input--ok', ok);
        emailEl.classList.toggle('ggm-input--error', !ok);
        if (ok) clearFieldError(emailEl);
      };

      emailEl.addEventListener('blur', applyEmailState);
      emailEl.addEventListener('input', applyEmailState);
    }

    // ===== Focus trap (A11y) =====
    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      if (!panel || !panel.classList.contains('show')) return;

      const focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );

      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('keydown', trapFocus);
    function safeLoadDraft() {
      try {
        const raw = localStorage.getItem(draftKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
      } catch (_) {
        return null;
      }
    }

    function safeSaveDraft(patch) {
      try {
        const current = safeLoadDraft() || {};
        const next = { ...current, ...patch, ts: Date.now() };
        localStorage.setItem(draftKey, JSON.stringify(next));
      } catch (_) {}
    }

    function maybePrefillFromDraft() {
      const d = safeLoadDraft();
      if (!d) return;

      if (nameEl && !nameEl.value.trim() && typeof d.name === 'string') nameEl.value = d.name;
      if (emailEl && !emailEl.value.trim() && typeof d.email === 'string') emailEl.value = d.email;
      const phoneEl = document.getElementById('ggmPhone');
      if (phoneEl && !phoneEl.value.trim() && typeof d.phone === 'string') phoneEl.value = d.phone;
      if (msgEl && !msgEl.value.trim() && typeof d.msg === 'string') msgEl.value = d.msg;
    }

    // ===== Prefill message + restore draft =====
    maybePrefillFromDraft();

    // autosave draft (lightweight)
    const phoneEl = document.getElementById('ggmPhone');
    const saveNow = () => safeSaveDraft({
      name: nameEl ? nameEl.value.trim() : '',
      email: emailEl ? emailEl.value.trim() : '',
      phone: phoneEl ? phoneEl.value.trim() : '',
      msg: msgEl ? msgEl.value : ''
    });

    let saveT = null;
    const scheduleSave = () => {
      clearTimeout(saveT);
      saveT = setTimeout(saveNow, 250);
    };

    [nameEl, emailEl, phoneEl, msgEl].forEach((el) => {
      if (!el) return;
      el.addEventListener('input', scheduleSave);
      el.addEventListener('blur', saveNow);
    });

    // ===== Quick actions =====
    const quickButtons = document.querySelectorAll('.ggm-quick__btn');
    if (quickButtons.length && msgEl) {
      quickButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          msgEl.value = btn.dataset.msg || '';
          msgEl.focus();
          scheduleSave();

          quickButtons.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
      });
    }

    // ===== Move nodes to <body> on storefront only =====
    if (!inEditor) {
      document.addEventListener('DOMContentLoaded', () => {
        const ids = ['ggmFab', 'ggmBackdrop', 'ggmPanel', 'ggmToast', 'ggmThanks'];

        ids.forEach((id) => {
          const el = document.getElementById(id);
          if (el && el.parentNode !== document.body) {
            document.body.appendChild(el);
          }
        });
      });
    }

    // ===== Manual open =====
    fab.addEventListener('click', (e) => {
      e.stopPropagation();

      if (!isOpen()) {
        setTimeout(openPanel, 120);
      } else {
        closePanel();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closePanel);
    }

    if (back) {
      back.addEventListener('click', closePanel);
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closePanel();
        hideThanks(true);
      }
    });

    if (thanksClose) {
      thanksClose.addEventListener('click', () => hideThanks(true));
    }

    if (thanks) {
      thanks.addEventListener('click', (e) => {
        if (e.target === thanks) hideThanks(true);
      });
    }

    // ===== Submit: required checks + rate limit + loading =====
    if (form) {
      form.addEventListener('submit', (e) => {
        const name = (nameEl && nameEl.value ? nameEl.value : '').trim();
        const email = (emailEl && emailEl.value ? emailEl.value : '').trim();

        if (websiteEl && websiteEl.value.trim()) {
          e.preventDefault();
          return;
        }

        if (!name) {
          e.preventDefault();
          setFieldError(nameEl, TEXT.required);
          scrollFieldIntoView(nameEl);
          if (nameEl) nameEl.focus();
          return;
        }

        if (!email) {
          e.preventDefault();
          setFieldError(emailEl, TEXT.required);
          scrollFieldIntoView(emailEl);
          if (emailEl) emailEl.focus();
          return;
        }

        if (emailEl && !validateEmail(email)) {
          e.preventDefault();
          setFieldError(emailEl, TEXT.invalidEmail);
          scrollFieldIntoView(emailEl);
          emailEl.focus();
          return;
        }

        // anti-spam: 1 submit per 60s (per tab)
        try {
          const lastSubmitKey = 'ggmLastSubmit_v1';
          const now = Date.now();
          const last = parseInt(sessionStorage.getItem(lastSubmitKey) || '0', 10);

          if (now - last < 60000) {
            e.preventDefault();
            showToast(i18n.waitMessage || 'Please wait a minute before sending another message.');
            return;
          }

          sessionStorage.setItem(lastSubmitKey, String(now));
        } catch (_) {}

        // loading state
        const sendBtn = document.getElementById('ggmSend');
        if (sendBtn) {
          sendBtn.classList.add('is-loading');
          sendBtn.setAttribute('aria-busy', 'true');
          sendBtn.setAttribute('disabled', 'disabled');
          sendBtn.dataset.ggmOldText = sendBtn.textContent;
          sendBtn.textContent = TEXT.sending;
        }

        try {
          sessionStorage.setItem(thanksPendingKey, '1');
        } catch (_) {}

        // snapshot draft after submit
        saveNow();
        closePanel();
      });
    }

    // ===== Show thanks after redirect =====
    try {
      const pending = sessionStorage.getItem(thanksPendingKey) === '1';
      const posted = new URLSearchParams(location.search).has('contact_posted');

      if (pending && posted) {
        sessionStorage.removeItem(thanksPendingKey);
        showThanks();

        const sendBtn = document.getElementById('ggmSend');
        if (sendBtn) {
          sendBtn.classList.remove('is-loading');
          sendBtn.removeAttribute('aria-busy');
          sendBtn.removeAttribute('disabled');
          if (sendBtn.dataset.ggmOldText) sendBtn.textContent = sendBtn.dataset.ggmOldText;
        }

        // clear saved draft after successful submit
        try {
          localStorage.removeItem(draftKey);
        } catch (_) {}

        if (history && history.replaceState) {
          history.replaceState({}, '', location.pathname + location.hash);
        }
      }
    } catch (_) {}

    // ===== Auto-open =====
    if (!alreadySeen && autoOpenAfterMs && !isNaN(autoOpenAfterMs) && autoOpenAfterMs > 0) {
      setTimeout(() => {
        if (!isOpen()) openPanel();
      }, autoOpenAfterMs);
    }
  }

  // normal load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGgmWidget);
  } else {
    initGgmWidget();
  }

  // Theme editor re-renders sections; re-init safely
  document.addEventListener('shopify:section:load', initGgmWidget);
})();

// ===== Cart guard: hide widget while cart drawer/modal is open =====
(function () {
  const inEditor = !!(window.Shopify && Shopify.designMode);

  function isVisible(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;

    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (Number(cs.opacity) === 0) return false;

    const r = el.getBoundingClientRect();
    return r.width > 10 && r.height > 10;
  }

  function isCartOpen() {
    // Dawn / OS2
    const cd = document.querySelector('cart-drawer');
    if (
      cd &&
      (
        cd.hasAttribute('open') ||
        cd.classList.contains('active') ||
        cd.classList.contains('is-open') ||
        isVisible(cd)
      )
    ) {
      return true;
    }

    // Common drawer ids/classes
    const drawer =
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="CartDrawer"]') ||
      document.querySelector('.cart-drawer') ||
      document.querySelector('.drawer--cart') ||
      document.querySelector('.drawer');

    if (isVisible(drawer)) return true;

    // Overlays
    const ov =
      document.querySelector('#CartDrawer-Overlay') ||
      document.querySelector('[id*="CartDrawer-Overlay"]') ||
      document.querySelector('.drawer-overlay') ||
      document.querySelector('.cart-drawer__overlay');

    if (isVisible(ov)) return true;

    // Modal cart
    const dlg = document.querySelector('dialog[open]');
    if (isVisible(dlg)) return true;

    const ariaModal = document.querySelector('[aria-modal="true"]:not([aria-hidden="true"])');
    if (isVisible(ariaModal)) return true;

    return false;
  }

  function closeWidgetIfOpen() {
    const panel = document.getElementById('ggmPanel');
    if (panel && panel.classList.contains('show')) {
      const closeBtn = document.getElementById('ggmClose');
      if (closeBtn) closeBtn.click();
    }

    const thanks = document.getElementById('ggmThanks');
    if (thanks && thanks.classList.contains('show')) {
      const thanksClose = document.getElementById('ggmThanksClose');
      if (thanksClose) thanksClose.click();
    }
  }

  function sync() {
    const open = isCartOpen();
    document.documentElement.classList.toggle('ggm-cart-open', open);
    if (open) closeWidgetIfOpen();
  }

  sync();
  setInterval(sync, inEditor ? 600 : 250);
})();